import { SEARCH_FILE_REFERENCES_REQUEST, searchFileReferencesSuccess, searchFileReferencesFailure } from 'Redux/Action';
import { ofType }                                                                                   from 'redux-observable';
import { from }                                                                                     from 'rxjs';
import { mergeMap }                                                                                 from 'rxjs/operators';
import { TEpic }                                                                                    from 'Redux/Config';

export const searchFileReferencesEpic: TEpic = (action$, store$, { FileReferenceRepository }) => {
  return action$.pipe(
    ofType(SEARCH_FILE_REFERENCES_REQUEST),
    mergeMap(action => from(
      FileReferenceRepository.findAll(action.payload)
        .then(({ fileReferences, meta }) => searchFileReferencesSuccess({
          fileReferences,
          response: meta,
          request: action
        }))
        .catch((error: Error) => searchFileReferencesFailure(error)),
    )),
  );
};
